// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"9509":"6f31d389","9619":"57487f4c"}[chunkId] || chunkId) + "." + {"521":"b766ef233d6cc968","6258":"a973b12b84e2361b","6341":"c595e9dd71f833d1","8436":"cab94b59cca0a8ff","8964":"e7c8a5a3686976bd","9509":"0ebc4a0984490edc","9619":"f826ea7eedce31c6"}[chunkId] + ".js";
};